<template>
  <div>
    <a-card title="客户经理管理" style="margin: 20px">
      <div class="loan">
        <div class="formbox">


          <div class="inputbox">
            <div class="lefttitle">机构名称</div>
            <a-input v-model.trim="form.operateOrgName" placeholder="请输入机构名称"/>
          </div>
          <div class="inputbox">
            <div class="lefttitle">机构号</div>
            <a-input v-model.trim="form.operateOrgId" placeholder="请输入机构号"/>
          </div>
          <div class="inputbox">
            <div class="lefttitle">姓名</div>
            <a-input v-model.trim="form.inputUserName" placeholder="请输入客户经理姓名"/>
          </div>
          <div class="inputbox">
            <div class="lefttitle">工号</div>
            <a-input v-model.trim="form.inputUserId" placeholder="请输入客户经理工号"/>
          </div>

          <!-- 查询 -->
          <a-button class="inquire" @click="search" type="primary" v-if="$authority('customerManagerQuery')">
            查询
          </a-button>
          <!-- 重置 -->
          <a-button @click="reset" class="reset">重置</a-button>
        </div>

        <div class="Applyfor">
          <a-button @click="addBtn" type="primary" v-if="$authority('customerManagerAdd')">新增</a-button>
          <a-button @click="editBtn" type="primary" v-if="$authority('customerManagerEdit')"> 编辑</a-button>
          <a-button @click="delBtn" type="danger" v-if="$authority('customerManagerDel')"> 删除</a-button>

        </div>
        <div class="tablebox">
          <!-- 表格 -->
          <div class="tableBody">
            <a-table ref="table" size="small" :rowKey="(record, index) => `${record.id}`" :row-selection="{
              selectedRowKeys: selectedRowKeys,
              hideDefaultSelections: true,
              onChange: onSelectChange,
            }" :columns="columns" :customRow="clickrow" :data-source="tableData" :pagination="false">

            </a-table>
          </div>
          <!-- 分页部分 -->
          <div class="paginationBox">
            <a-button class="Homepage" :disabled="Number(form.pageNo) == 1" @click="Homepage">
              首页
            </a-button>
            <a-pagination v-model.trim="form.pageNo" :page-size-options="pageSizeOptions" :total="total"
                          show-size-changer :page-size="form.pageSize" @change="pagechange" @showSizeChange="onShowSizeChange"
                          :item-render="itemRender">

            </a-pagination>
            <a-button @click="Trailingpage" :disabled="form.pageNo == Math.ceil(Number(total) / Number(form.pageSize))"
                      class="Trailingpage">
              尾页
            </a-button>
          </div>
        </div>
      </div>
    </a-card>
    <a-modal :title="formData.id ? '编辑' : '新增'" class="formData" :visible="modalBool" @ok="handleOk"
             @cancel="modalBool = false">
      <a-form :model="formData" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">

        <a-form-item label="机构号">
          <a-input v-model="formData.operateOrgId" placeholder="如'15613'"/>
        </a-form-item>
        <a-form-item label="机构名称">
          <a-input v-model="formData.operateOrgName" placeholder="前两个汉字写分行，如'上海松江支行'"/>
        </a-form-item>
        <a-form-item label="工号">
          <a-input v-model="formData.inputUserId" placeholder="如'12345'"/>
        </a-form-item>
        <a-form-item label="姓名">
          <a-input v-model="formData.inputUserName" />
        </a-form-item>
<!--        <a-form-item label="法人机构号">-->
<!--          <a-input v-model="formData.corpOrgId"/>-->
<!--        </a-form-item>-->
<!--        <a-form-item label="法人机构">-->
<!--          <a-input v-model="formData.corpOrgName"/>-->
<!--        </a-form-item>-->

<!--        <a-form-item label="联系方式">-->
<!--          <a-input v-model="formData.mobile"/>-->
<!--        </a-form-item>-->
<!--        <a-form-item label="电子邮箱">-->
<!--          <a-input v-model="formData.email"/>-->
<!--        </a-form-item>-->

      </a-form>
    </a-modal>
    <!-- 删除 -->
    <a-modal title="提示" :maskClosable="true" @cancel="deleteshow = false" :centered="true" :visible="deleteshow">
      <div class="Openanaccount">
        是否确认删除所勾选数据？删除后数据将不可恢复
      </div>
      <template v-slot:footer>
        <div class="custom-footer">
          <a-button type="primary" @click="Confirmdelete">确认</a-button>
          <a-button @click="deleteshow = false">取消</a-button>
        </div>
      </template>
    </a-modal>

  </div>
</template>

<script>
export default {
  name: 'customerManager',
  data() {
    return {
      deleteshow: false,
      total: 0,
      modalBool: false,
      selectedRowKeys: [],
      selectedRows: [],
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      tableData: [],
      formData: {
        corpOrgId: "",
        corpOrgName: "",
        inputUserId: "",
        inputUserName: "",
        operateOrgId: "",
        operateOrgName: "",
        mobile: "",
        email: ""

      },
      form: {
        pageNo: 1,
        pageSize: 10,
        corpOrgId: "",
        corpOrgName: "",
        inputUserId: "",
        inputUserName: "",
        operateOrgId: "",
        operateOrgName: "",
        mobile: "",
        email: ""
      },
      columns: [
        {
          title: 'No',
          dataIndex: 'No',
          customRender: (_, __, index) => {
            const currentPage = Number(this.form.pageNo);
            const size = Number(this.form.pageSize);
            return `${(currentPage - 1) * size + index + 1}`;
          },
          align: 'center'
        },

        {
          title: '机构号',
          dataIndex: 'operateOrgId',
          align: 'center'
        },
        {
          title: '机构名称',
          dataIndex: 'operateOrgName',
          align: 'center'
        },
        {
          title: '工号',
          dataIndex: 'inputUserId',
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'inputUserName',
          align: 'center'
        },
        // {
        //   title: '法人机构号',
        //   dataIndex: 'corpOrgId',
        //   align: 'center'
        // },
        // {
        //   title: '法人机构',
        //   dataIndex: 'corpOrgName',
        //   align: 'center'
        // },
      ]
    };
  },
  created() {
    this.getPage();
  },
  methods: {
    async getPage() {
      const res = await this.api.findCustomerManagerPageApi(this.form);
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }
      this.total = res.data.total;
      this.form.pageNo = res.data.current;
      this.form.pageSize = res.data.size;
      this.tableData = res.data.records;
    },

    addBtn() {
      this.formData = {
        corpOrgId: "15601",
        corpOrgName: "稠州银行",
        inputUserId: "",
        inputUserName: "",
        operateOrgId: "",
        operateOrgName: "",
        mobile: "",
        email: ""
      };
      this.modalBool = true;
    },

    reset() {
      Object.assign(this.form, {
        pageNo: 1,
        pageSize: 10,
        corpOrgId: "",
        corpOrgName: "",
        inputUserId: "",
        inputUserName: "",
        operateOrgId: "",
        operateOrgName: "",
        mobile: "",
        email: ""
      });
      this.getPage();
    },

    onShowSizeChange(current, pageSize) {
      this.form.pageSize = pageSize;
      this.getPage();
    },

    itemRender(current, type, originalElement) {
      if (type === 'prev') return <a>上一页</a>;
      if (type === 'next') return <a>下一页</a>;
      return originalElement;
    },

    Homepage() {
      if (this.total <= 0) return;
      this.form.pageNo = 1;
      this.getPage();
    },

    Trailingpage() {
      if (this.total <= 0) return;
      const totalPages = Math.ceil(Number(this.total) / Number(this.form.pageSize));
      this.form.pageNo = totalPages;
      this.getPage();
    },

    pagechange(val) {
      this.form.pageNo = val;
      this.getPage();
    },

    search() {
      this.form.pageNo = 1;
      this.getPage();
    },

    handleOk() {


      const apiCall = this.formData.id
          ? this.api.updateCustomerManagerApi(this.formData)
          : this.api.addCustomerManagerApi(this.formData);

      apiCall
          .then(res => {
            if (res.code !== 200) {
              this.$message.warning(res.info);
              return;
            }

            const message = this.formData.id ? '编辑成功' : '新增成功';
            this.$message.success(message);
            this.resetAndRefresh();
          })
          .catch(error => {
            console.error('API 请求失败:', error);
            this.$message.error('请求失败，请稍后再试');
          });


    },

    resetAndRefresh() {
      this.formData = {
        corpOrgId: "",
        corpOrgName: "",
        inputUserId: "",
        inputUserName: "",
        operateOrgId: "",
        operateOrgName: "",
        mobile: "",
        email: ""
      };
      this.modalBool = false;
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.getPage();
    },

    editBtn() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择数据');
        return;
      }
      if (this.selectedRows.length > 1) {
        this.$message.warning('只能选择一个数据');
        return;
      }
      this.formData = JSON.parse(JSON.stringify(this.selectedRows[0]));
      this.modalBool = true;
    },

    delBtn() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择数据');
        return;
      }
      this.deleteshow = true;
    },

    async Confirmdelete() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请先选择要删除的数据');
        return;
      }

      try {
        const ids = this.selectedRows
            .map(item => item.id)
            .filter(id => id != null); // 过滤无效ID

        if (ids.length === 0) {
          this.$message.warning('所选数据无有效ID');
          return;
        }

        const res = await this.api.deleteCustomerManagerApi(ids);

        if (!res || typeof res !== 'object') {
          this.$message.error('接口返回异常');
          return;
        }

        if (res.code !== 200) {
          this.$message.error(res.info || '删除失败');
          return;
        }

        this.$message.success('删除成功');
        this.selectedRowKeys = [];
        this.selectedRows = [];
        this.deleteshow = false;
        this.getPage();
      } catch (error) {
        console.error('删除客户经理时发生异常:', error);
        this.$message.error('删除过程中发生错误，请稍后再试');
      }
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },

    clickrow(record) {
      return {
        on: {
          click: () => {
            const id = record.id?.toString();
            if (!id) return;

            const index = this.selectedRowKeys.findIndex(item => item === id);
            if (index === -1) {
              this.selectedRowKeys.push(id);
              this.selectedRows.push(record);
            } else {
              this.selectedRowKeys.splice(index, 1);
              this.selectedRows.splice(index, 1);
            }
          }
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

.addform {

  .context {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .ant-form-item {
      width: 368px;


    }
  }

  .ant-modal {
    width: 1200px !important;
  }

  .ant-modal-content {

    width: 1200px;
  }
}

.ant-card-head-title {
  font-size: 14px;
  font-weight: 600;
}

/* 自定义表头样式 */
.ant-table-thead > tr > th {
  background-color: #f2f2f2;
}

.ant-modal-footer {

  padding-bottom: 20px;
}

.ant-modal-content {
  min-width: 420px;
}


.loan {
  .formbox {
    display: flex;
    flex-wrap: wrap;

    .inputbox {
      width: 260px;
      margin-right: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      input {
        width: 180px;
      }

      .lefttitle {
        min-width: 80px;
      }
    }

    .zhaungtai {
      width: 280px;
      margin-right: 120px;
    }

    .reset {
      width: 64px;
      padding: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }

    button {
      margin-bottom: 20px;
    }

    .ant-tag {
      cursor: pointer;
    }
  }

  .tablebox {
    width: 100%;
    height: 100%;
    margin-bottom: 20px;

    .ant-tag {
      cursor: pointer;
    }
  }

  .paginationBox {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;

    // .ant-pagination-options {
    //   float: left;
    // }

    .ant-pagination-prev,
    .ant-pagination-next,
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next {
      border: 1px solid #d9d9d9;
      width: 60px;
    }
  }

  .Applyfor {
    padding-top: 10px;
    margin-bottom: 20px;
  }
}
</style>
